module.exports = __webpack_public_path__ + "static/media/wavePattern.0bf22ed1.png";